<p class="small no-margin fw-600" *ngIf='openCloseTime?.open && openCloseTime?.close'>
  <ng-container *ngTemplateOutlet="orderTypeIsAny ? orderTypeAnyTemplate : selectedOrderTypeTemplate"></ng-container>
  <br *ngIf="multiline">
  {{openCloseTime.open | dateFormat: 'h:mm a'}} - {{openCloseTime.close | dateFormat: 'h:mm a'}}
</p>

<ng-template #selectedOrderTypeTemplate>{{orderType | orderTypeName | async}} {{'component.store_open_close_time.hours' | translate}}:</ng-template>
<ng-template #orderTypeAnyTemplate>{{'component.store_open_close_time.hours' | translate | titlecase}}:</ng-template>